<template>
  <v-dialog v-model="dialog" persistent max-width="360">
    <v-card v-if="action == 'reset-password'">
      <v-card-title class="headline"> Reset password </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-text-field
              v-model="newPassword"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required]"
              :type="showPassword ? 'text' : 'password'"
              name="password"
              label="New password"
              v-on:keyup.enter="confirm"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.matchPassword]"
              :type="showPassword ? 'text' : 'password'"
              name="password"
              label="Repeat new password"
              v-on:keyup.enter="confirm"
            ></v-text-field>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="showLogin()"> Cancel </v-btn>
        <v-btn text @click="resetPassword()">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="action == 'first-login'">
      <v-card-title class="headline"> Finalize registration </v-card-title>
      <v-card-text>
        <v-container>
          <v-row class="mb-2">
            This is your first time login to Jobs in Finland. Please set a
            password for your account and accept the Terms of Use.
          </v-row>
          <v-row>
            <v-text-field
              v-model="newPassword"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required]"
              :type="showPassword ? 'text' : 'password'"
              name="password"
              label="New password"
              v-on:keyup.enter="confirm"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.matchPassword]"
              :type="showPassword ? 'text' : 'password'"
              name="password"
              label="Repeat new password"
              v-on:keyup.enter="confirm"
            ></v-text-field>
          </v-row>
          <v-row class="align-center mt-6 flex-nowrap" dense>
            <v-checkbox v-model="termsAccepted" dense></v-checkbox>
            <label class="mb-2"
              >I have read and accept the
              <a @click="termsDialog = true">{{ terms.title }}</a
              >.</label
            >
          </v-row>
          <TermsModal :show.sync="termsDialog" :terms="terms"></TermsModal>
          <ForgotPasswordModal
                :show.sync="forgotPassword"
                username=""
          ></ForgotPasswordModal>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="showLogin()"> Cancel </v-btn>
        <v-btn
          text
          @click="forgotPassword = true"
          >Resend email</v-btn>
        <v-btn text @click="resetPassword()" :disabled="!termsAccepted">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title class="headline"> Admin login </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-text-field
              v-model="lcUsername"
              :rules="[rules.required]"
              name="username"
              label="Username"
              v-on:keyup.enter="confirm"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              v-model="credentials.password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required]"
              :type="showPassword ? 'text' : 'password'"
              name="password"
              label="Password"
              v-on:keyup.enter="confirm"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-alert
              v-if="alert !== null"
              dense
              outlined
              type="error"
              :icon="false"
            >
              {{ alert }}
            </v-alert>
          </v-row>
          <v-row class="align-center mt-6 flex-nowrap" dense>
            <v-checkbox v-model="termsAccepted" dense></v-checkbox>
            <label class="mb-2"
              >I have read and accept the
              <a @click="termsDialog = true">{{ terms.title }}</a
              >.</label
            >
          </v-row>
          <TermsModal :show.sync="termsDialog" :terms="terms"></TermsModal>
          <v-row class="align-center mt-6" dense>
            <v-btn
              block
              @click="confirm"
              :disabled="!termsAccepted"
              color="primary"
              elevation="0"
              >Login</v-btn
            >
            <v-btn
              text
              block
              class="mt-6"
              @click="forgotPassword = true"
              color="primary"
              >Forgot password?</v-btn
            >
          </v-row>
          <ForgotPasswordModal
            :show.sync="forgotPassword"
            :username="credentials.username"
          ></ForgotPasswordModal>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import TermsModal from "@/components/TermsModal.vue";
import ForgotPasswordModal from "@/components/ForgotPasswordModal.vue";

export default {
  name: "loginModal",
  components: {
    TermsModal,
    ForgotPasswordModal,
  },
  props: {
    show: Boolean,
    alert: String,
    action: String,
  },
  data() {
    return {
      dialog: false,
      showPassword: false,
      credentials: {
        username: "",
        password: "",
      },
      newPassword: "",
      rules: {
        required: (value) => !!value || "Required.",
        matchPassword: (value) =>
          value == this.newPassword || "Passwords do not match.",
      },
      termsAccepted: false,
      termsDialog: false,
      terms: {},
      forgotPassword: false,
    };
  },
  mounted() {
    // Check if token has been provided when user is doing first time onboarding
    if (
      this.$route.name == "first-login" &&
      this.$route.query.token == undefined
    ) {
      this.showLogin();
    }

    this.$store.dispatch("dispatchGetPages").then((pages) => {
      this.terms = pages.find(
        (page) => page.id == "terms-of-use-for-job-poster"
      );
    });
  },
  computed: {
    token: function () {
      return this.$route.query.token;
    },
    lcUsername: {
      get(){
        return this.credentials.username;
      },
      set(value){
        this.credentials.username = value.toLowerCase()
      }
    }
  },
  methods: {
    confirm() {
      this.$emit(
        "credentials",
        this.credentials.username,
        this.credentials.password
      );
      this.dialog = false;
    },
    resetPassword() {
      this.$store
        .dispatch("dispatchResetPassword", {
          token: this.token,
          newPassword: this.newPassword,
        })
        .then((res) => {
          this.showLogin(true);
        }).catch(() => {
          this.$store.dispatch("commitSnackbar", { show: true, message: "Your password reset token was invalid. Please try resending the verification email.", timeout: 4000, color: "error" });
        });
    },
    showLogin(firstLogin = false) {
      // Hard navigate to admin login
      location.replace("/admin" + (firstLogin ? '?action=onboarding' : ''));
    }
  },
  watch: {
    show: function (showLogin) {
      console.log("show login called");
      this.dialog = showLogin;
    },
  }
};
</script>